export default __webpack_public_path__ + "static/Olivier-photo-de-profil-7e633079bd6d76bd11947ad674c1bfb2.jpg";